import React from "react";

const UrlTagExtractor = ({ url }) => {
  if (!url) return null;

  
  const getTags = (urlStr) => {
    try {
        const urlObj = new URL(urlStr);

        if (urlObj.hostname.includes("docs.google.com")) {
            return []; // Return nothing, or return ["Google Doc"] if you want a label
        }

        const isHelpSubdomain = urlObj.hostname.startsWith("help.");
        const segments = urlObj.pathname.split("/").filter((s) => s.length > 0);

        let tags = [];
        const isHelpContext = isHelpSubdomain || segments[0] === "help";

        // 1. Handle Help Logic
        if (isHelpContext) {
        tags.push("Help Articles");

        let helpSegments = isHelpSubdomain ? segments : segments.slice(1);

        // Remove redundant "Help" folder if it exists
        if (helpSegments[0] && helpSegments[0].toLowerCase() === "help") {
            helpSegments = helpSegments.slice(1);
        }

        // CHANGE: If it's a help article, only show additional tags if there 
        // are actual categories before the article (length > 1)
        if (helpSegments.length > 1) {
            const categories = helpSegments.slice(0, -1).map(s => formatLabel(s));
            tags = [...tags, ...categories];
        }
        // If helpSegments.length is 1, it's just the article name, so we do nothing.
        } 
        // 2. Standard Multiple categories (muvi.com/cat1/cat2/page)
        else if (segments.length > 2) {
        tags = segments.slice(0, -1).map(s => formatLabel(s));
        }
        // 3. Single category or Flat URL
        else if (segments.length >= 1) {
        tags = [formatLabel(segments[0])];
        }

        return tags;
    } catch (e) {
        return ["Link"];
    }

};

  const formatLabel = (slug) => {
    return decodeURIComponent(slug)
      .replace(/-/g, " ")
      .replace(/\.[^/.]+$/, "")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const allTags = getTags(url);

  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginBottom: "8px" }}>
      {allTags.map((tag, index) => (
        <span
          key={index}
          style={{
            padding: "2px 8px",
            borderRadius: "4px",
            fontSize: "10px",
            fontWeight: "700",
            backgroundColor: tag === "Help Articles" ? "#E3F2FD" : "#F5F5F5",
            color: tag === "Help Articles" ? "#1976D2" : "#616161",
            border: `1px solid ${tag === "Help Articles" ? "#BBDEFB" : "#E0E0E0"}`,
            textTransform: "uppercase",
            margin: "2px 0"
          }}
        >
          {tag}
        </span>
      ))}
    </div>
  );
};

export default UrlTagExtractor;


// WEBPACK FOOTER //
// ./src/components/ai/UrlTagExtractor.js